export default {
  '405': 'Incorrect password',
  '406': 'User does not exist',
  '407': 'Parameters do not match',
  '408': 'Passwords do not match',
  '409': 'Incorrect password',
  '411': 'User already exists',
  '412': 'Password length is not 6-16',
  '413': 'The mobile number has already been registered',
  '414': 'The end time cannot be less than the start time.',
  '415': 'Please select start date',
  '416': 'Please select end date',
  '417': 'Please select trading account',
  '500': 'Server error, please contact customer service.',
  '5002': 'Error retrieving balance',
  '5003': 'Account error, please contact customer service',
  '5004': 'Failed to retrieve user email template, please contact customer service.',
  '6002': 'Error sending email',
  '11000': 'Failed to retrieve balance, please contact customer service',
  '51001': 'The account information does not exist',
  '51002': 'The trading account does not exist',
  '51003': 'The trading account type does not exist',
  '51004': 'The trading account type is incorrect'
}
